/**
 * Service for fetching for an ope
 */

var VRC = VRC || {};

VRC.VoyageService = (function(){

  var CHECK_SUBMIT_TYPE = 'check_for_open_voyages';

  var TYPES = {
    OPEN_VOYAGE : 'OPEN_VOYAGE',
    AVAILABLE_VOYAGES : 'AVAILABLE_VOYAGES',
    NO_VOYAGES : 'NO_VOYAGES'
  };

  var check = function(){
    var deffered = $.Deferred();

    var checking =  VRC.CommunicationService.fetchData(null, CHECK_SUBMIT_TYPE, []);

    checking.done(function(owner, data){

      var status = TYPES.NO_VOYAGES;

      if(data.voyage){
        status = TYPES.OPEN_VOYAGE;
        importVoyage(data);
      }
      else if(_.isArray(data)) {
        if (data.length > 0) {
          status = TYPES.AVAILABLE_VOYAGES;
        }
      }

      deffered.resolve(status, data);
    });

    checking.fail(function(owner, data){
      deffered.reject(owner, data);
    });

    return deffered.promise()
  };


  var validateImport = function(data){
    var noErrors = true;
    if(!data){
      noErrors = 'Data is undefined';
    }
    else if(data.voyageLogs === undefined){
      noErrors = 'Voyage logs are missing';
    }
    else if(data.deck === undefined){
      noErrors = 'Deck is missing';
    }
    else if(data.deck.containers === undefined){
      noErrors = 'Containers is missing';
    }

    return noErrors;
  };

  var importVoyage = function(data){

    var voyage = VRC.CurrentVoyage.getCurrentVoyage();

    var isValid = validateImport(data);

    if(isValid === true){
      voyage.startNewVoyage(data.voyage);
      VRC.VoyageLogEntryManager.importVoyageLogs(data.voyageLogs);
      VRC.ContainerManager.importContainers(data.deck.containers);
      VRC.BulkTankManager.importBulkData(data.bulk);

    }
    else{
      console.error(isValid);
    }
  };

  return {
    TYPES : TYPES,
    check : check
  }
})();